<template>
	<div>
		<div class="col-lg-12">
  			<p @click="backFolder()" class="c-pointer"><i aria-hidden="true" class="fa fa-arrow-left "></i> Назад</p>
			<div class="modal-menu-folder md " :class="{ isOpen: isOpen == true }">

				<div class="content-modal content-modal-folder content-modal-folder-menu-folder">

					<template  v-for="item in items">

						<li v-if="item.type !== 'folder'"  class="folder" @dblclick="clickImage(item)">
							<div class="wrap-all-content-folder">

								<div class="wrap-icon-folder"><img class="img-bottom-files"  :src="item.icon" :alt="item.icon" ></div>
							</div>
							<div class="info-folder" >

								<span 
								@blur="changeActiveOptions(item.id)"
								@click.stop="changeActiveOptions(item.id)"
								class="option-folder">

								<i aria-hidden="true" class="fa fa-ellipsis-h"></i></span> <span class="name-folder">{{ item.title }}</span> <span class="type-folder">{{ item.type }}</span>

								<div :class="{ show: item.id == activeId }" class="wrap-option-folder-menu"  >
									<ul class="option-folder-menu  table-option-wrap">
										<li v-if="item.type == 'folder'" @click="clickImage(item)"> Отвори</li>
										<li v-if="item.type != 'pdf'" @click="openModalCreateFolder(item)"> Редактирай</li>
										<li  @click="removeFile(item, index)"> Изтрий</li>
									</ul>
								</div> 
							</div>
						</li>

						<li v-else class="folder" @dblclick="clickImage(item)"> 
							<div class="wrap-all-content-folder">

								<div class="wrap-icon-folder"><img :src="item.icon" :alt="item.icon"></div>
							</div>
							<div class="info-folder" >

								<span 
								@blur="changeActiveOptions(item.id)"
								@click.stop="changeActiveOptions(item.id)" 
								class="option-folder">

								<i aria-hidden="true" class="fa fa-ellipsis-h"></i></span> <span class="name-folder">{{ item.title }}</span> <span class="type-folder">{{ item.type }}</span>

								<div :class="{ show: item.id == activeId }" class="wrap-option-folder-menu"  >
									<ul class="option-folder-menu  table-option-wrap">
										<li v-if="item.type == 'folder'" @click="clickImage(item)"> Отвори</li>
										<li v-if="item.type != 'pdf'" @click="openModalCreateFolder(item)"> Редактирай</li>
										<li  @click="removeFile(item, index)"> Изтрий</li>
									</ul>
								</div> 
							</div>
						</li>

					</template>


				</div>

			</div>


		</div>
	</div>
</template>

<script>

	import axios from 'axios'

	import filemanager from '../../mixins/filemanager'

	export default {
		name: 'files-block',

		data() {
			return {
				typeFiles: 'pdf',
			}
		},
		created() {

		},
		mixins: [ filemanager],



	}

</script>

<style scoped>
.img-bottom-files {
	position: relative;
	background: #eaeaea;
	height: 100px;
	display: inline-block;
	margin: 0 20px 50px 0;
	border-radius: 3px;
}
.dragArea {
	height: 300px;
	overflow: auto;
}
input[type="file"] {
	display:none;
}

.wrap-option-folder-menu {
	display:none;
}
.show {
	display: block!important;
}
.modal-h6 {
	cursor:pointer;
}
.isOpen {
	top:70%!important;
}
.uploadButton {
	font-size: 13px;
	cursor: pointer;
}
.list-folder {
	font-size: 13px;
}
.list-folder-menu-folder li:hover {
	cursor: pointer;
}
.list-folder-menu-folder li {
	padding-right: 15px;
	display: inline-block;
}
/*.modal-menu-folder {
	height: 200px;
	overflow: auto;
	position: fixed;
	width: 100%;
	padding-left: 20px;
	left:0; 
	top:95%;
	z-index: 999999;
	background: #fff;
	}*/
	svg:not(:root){overflow:hidden;}
	.remaining .option-folder {
		display: none!important;
	}
	.checkbox-folder {
		display: -ms-inline-flexbox;
		display: inline-flex;
		-ms-flex-align: center;
		align-items: center;
		position: relative;
		height: 32px;
		max-width: 100%;
		margin-right: 16px;
		vertical-align: top;
	}

	.checkbox-folder-input {
		font-family: inherit;
		font-size: 100%;
		line-height: 1.15;
		margin: 0;
		overflow: visible;
		box-sizing: border-box;
		padding: 0;
		position: absolute;
		top: 0;
		left: -8px;
		width: calc(100% + 16px);
		height: 100%;
		opacity: .0001;
		z-index: 1;
		cursor: pointer;
	}

	.checkbox-folder-input:disabled {
		cursor: default;
	}

	.checkbox-folder-input:checked + .checkbox-folder-box {
		border-width: 7px;
	}

	.checkbox-folder-box {
		position: relative;
		box-sizing: border-box;
		width: 10px;
		height: 10px;
		-ms-flex-positive: 0;
		flex-grow: 0;
		-ms-flex-negative: 0;
		flex-shrink: 0;
		border-radius: 2px;
		color: #006886;
		border-width: 2px;
		border-style: solid;
		transition: border 125ms ease-in-out, box-shadow 125ms ease-in-out;
	}

	.wrap-checkbox {
		position: absolute;
		display: none;
	}

	.wrap-checkbox .checkbox-folder {
		margin-left: 8px;
		margin-right: 8px;
	}

	.wrap-checkbox {
		z-index: 1;
		top: 16px;
		left: 16px;
		padding: 0px 2px;
		opacity: .85;
		border-radius: 4px;
		background-color: #fff;
	}

	li {
		list-style: none;
		font-size: 15px;
	}

	ul {
		padding: 0;
	}

	.checked {
	}

	.checked .wrap-all-content-folder {
		border: 2px solid #247c95;
		background-color: #ccc !important;
		box-sizing: border-box;
		padding: 2px;
	}

	.folders .checked .option-folder {
		display: none !important;
	}


	.active {
		background-color: rgba(44, 44, 44, .06);
	}

	.wrap-all-content-folder {
		border-radius: inherit;
		width: 100%;
		height: 100%;
		flex: 1;
		display: flex;
		align-items: center;
	}

	.info-folder {
		position: relative;
	}

	.folder {
		position: relative;
		background: #eaeaea;
		width: 100px;
		height: 100px;
		display: inline-block;
		float:left;
		margin: 0 20px 50px 0;
		border-radius: 3px;
	}

	.folder:hover {
		background: #ccc;
		cursor: pointer;
	}

	.wrap-icon-folder {
		height: 64px;
		margin: 0 auto;
	}

	.folder img {
		height: 90%;
	}

	.name-folder {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #2c2c2c;
		font-size: 14px;
		display: block;
		margin-top: 10px;
	}

	.type-folder {
		color: #707070;
		letter-spacing: .666px;
		text-transform: uppercase;
		white-space: nowrap;
		overflow: hidden;
		font-size: 10px !important;
		font-weight: 600;
		text-overflow: ellipsis;
	}

	.wrap-all-content-folder.active {
		border: 1px solid #006886;
	}

	.option-folder {
		display: none;
		float: right;
		margin-top: 5px;
		color: #4b4b4b;
		font-size: 17px;
	}

	checked.option-folder {
		display: block;
	}

	.checked .wrap-checkbox {
		display: block;
	}

	.folder:hover .option-folder {
		display: block;
	}

	.folder:hover .wrap-checkbox {
		display: block;
	}

	.option-folder i {
		padding: 3px 4px;
	}

	.option-folder i:hover {
		background-color: #e1e1e1;
		border-radius: 3px;
	}

	.option-folder-menu li {
		font-size: 13px;
		font-weight: 400;
		font-style: normal;
		background-color: transparent;
		color: #4b4b4b;
		height: 10px;
		cursor: pointer;
		display: -ms-flexbox;
		-ms-flex-align: center;
		padding: 7px 12px 7px 10px;
		margin: 5px;
		min-height: 32px;
	}

	.option-folder-menu li:hover {
		background: #ddd;
	}

	.option-folder.active {
		background: #e1e1e1;
		color: #000;
		border-radius: 3px;
	}

	.checkbox-folder-input:checked + .checkbox-folder-box {
		border-width: 5px;
	}

	.wrap-checkbox .checkbox-folder {
		margin-left: 8px;
		margin-right: 8px;
	}


	input {
		color: inherit;
		font: inherit;
		margin: 0;
	}

	input::-moz-focus-inner {
		border: 0;
		padding: 0;
	}

	input {
		line-height: normal;
	}

	input[type=checkbox] {
		box-sizing: border-box;
		padding: 0;
	}

	li {
		list-style: none;
		font-size: 15px;
	}

	ul {
		padding: 0;
	}

	.option-folder-menu {
		position: absolute;
		z-index: 999999990000000000000099999;
		background-color: #fff;
		border: 1px solid #cacaca;
		width: 180px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, .15);
		border-radius: 3px;
		right: 0;
		bottom: 24px;
	}

	.option-folder-menu li {
		font-size: 13px;
		font-weight: 400;
		font-style: normal;
		background-color: transparent;
		color: #4b4b4b;
		height: 10px;
		cursor: pointer;
		display: -ms-flexbox;
		-ms-flex-align: center;
		padding: 7px 12px 7px 10px;
		margin: 5px;
		min-height: 32px;
	}

	.option-folder-menu li:hover {
		background: #ddd;
	}
	.information-file li {
		font-size: 12px;
		margin-right: 15px;
		color:#666;
		display: inline-block;
	}
</style>


// WEBPACK FOOTER //
// src/components/app_modules/FilesBlock.vue